<div class="status-container" [ngClass]="getClass()">
    <div *ngIf="standaloneMode">{{ date | momentFormat:'DD/MM/YY HH:mm:ss'}}</div>
    <div>
        <div *ngIf="!standaloneMode" class="name">{{whoChanged}}</div>

        <span  class="status" [ngClass]="{'normal': status === 0}">
            {{ l('allocationEnum_' + allocationSheetStatus[status]) }}
        </span>
        <span *ngIf="standaloneMode" class="name">({{whoChanged}})</span>
        <div *ngIf="reason && showReason"> {{ reason }}</div>
    </div>
</div>